import { Cohort } from 'nove8/constants/root-constants'
import { syncWoofyCreative } from 'nove8/cohorts/woofz_woofy1/helpers/syncWoofyCreative'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useWoofyInitial = () => {
  const { search } = useLocation()
  const creativeId = new URLSearchParams(search).get('ad_name')
  const { leadId, cohort, firebaseRemoteConfig } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id,
      cohort: state.lead?.cohort,
      firebaseRemoteConfig: state.firebaseRemoteConfig,
    })),
  )

  useEffect(() => {
    if (
      !leadId ||
      cohort !== Cohort.WOOFZ_WOOFY1 ||
      !firebaseRemoteConfig ||
      !creativeId
    ) {
      return
    }

    syncWoofyCreative({ creativeId, leadId, firebaseRemoteConfig })
  }, [leadId, cohort, creativeId, firebaseRemoteConfig])
}
